import { render, staticRenderFns } from "./AnalisisAceite.vue?vue&type=template&id=65b56216&scoped=true"
import script from "./AnalisisAceite.vue?vue&type=script&lang=js"
export * from "./AnalisisAceite.vue?vue&type=script&lang=js"
import style0 from "./AnalisisAceite.vue?vue&type=style&index=0&id=65b56216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b56216",
  null
  
)

export default component.exports